<div *ngIf="uiService.backButtonState.visible" class="footer-button">
  <a id="back" type="button" class="btn btn-warning button-base back-button" [class.disabled]="!uiService.backButtonState.enabled"
    (click)="onClick()">{{ uiService.backButtonState.text | translate }}</a>
</div>
